module.exports = __webpack_public_path__ + "media/volvo/assets/images/promo@2x-dc62f15804f832fac162858ba745fbd2.png";